/* eslint max-classes-per-file: 0 */

import {
  Formdata as Data,
  FormdataCollection as Collection,
} from '@/typings/api/Formdata'
import { FormTemplate } from '@/typings/api/FormTemplate'

import { FormTemplatesApi } from '@/api/resources'
import { Fabric } from '@/store/createCrudModule'
import { LKFormdataAdapter } from './LKFormdataAdapter'
import { DataCollection } from '@/typings/api/DataCollection'
import { User } from '@/typings/api/User'


export const fabric = Fabric<Data, Collection>()

type S = LKFormdataState
type G = LKFormdataGetters
type M = LKFormdataMutations
type A = LKFormdataActions


export class LKFormdataState extends fabric.State {
  public formTemplate: FormTemplate | null = null;

  public history: Record<string, unknown>[] | null = null;

  public revisions: Record<string, unknown>[] | null = null;
}

export class LKFormdataGetters extends fabric.Getters<S> {
}

export class LKFormdataMutations extends fabric.Mutations<S> {
  public setFormTemplate(payload?: FormTemplate) {
    this.state.formTemplate = payload || null
  }

  public setHistory(payload?: Record<string, unknown>[]) {
    this.state.history = payload || null
  }

  public setRevisions(payload?: Record<string, unknown>[]) {
    this.state.revisions = payload || null
  }
}

export class LKFormdataActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new LKFormdataAdapter();

  protected readonly formTemplatesApi = new FormTemplatesApi();

  protected readonly idName = 'id';

  public async getFormTemplate(id: FormTemplate['id']) {
    const { data } = await this.formTemplatesApi.getOne(id)
    this.mutations.setFormTemplate(data)

    return data
  }

  public createForm({ id, userId }: { id: DataCollection['id']; userId: User['id']}) {
    return this.adapter.api.create({ data: [], data_collection_id: id, user_id: userId })
  }

  public opened({ id }: { id: FormTemplate['id'] }) {
    return this.adapter.api.opened(id)
  }

  public submit({ id, close }: { id: FormTemplate['id']; close: boolean }) {
    const params = { close }
    return this.adapter.api.submit(id, params)
  }

  public updateDraft({ id, data }: { id: Data['id']; data: Data['data'] }) {
    // @ts-ignore  data is a dict but not sure
    return this.adapter.api.update(id, { data })
  }

  public async history(params: { id: FormTemplate['id'] }) {
    const { data } = await this.adapter.api.history(params.id)
    this.mutations.setHistory(data)
  }

  public async revisions(params: { id: FormTemplate['id'] }) {
    const { data } = await this.adapter.api.revisions(params.id)
    this.mutations.setRevisions(data)
  }

  public async revision(params: { id: FormTemplate['id']; revision_id: number }) {
    const { data } = await this.adapter.api.revision(params.id, params)
    return data
  }

  public updateStatus(params: { id: FormTemplate['id'] }) {
    return this.adapter.api.updateStatus(params.id, params)
  }

  public getNotStarted(params: { data_collection_id: DataCollection['id'] }) {
    return this.adapter.api.getNotStarted(params.data_collection_id, params)
  }
}
